import { render, staticRenderFns } from "./Courselist.vue?vue&type=template&id=13f521a5&scoped=true&"
import script from "./Courselist.vue?vue&type=script&lang=js&"
export * from "./Courselist.vue?vue&type=script&lang=js&"
import style0 from "./Courselist.vue?vue&type=style&index=0&id=13f521a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f521a5",
  null
  
)

export default component.exports